import React, { Component } from "react";
import { Route, Redirect } from "react-router-dom";
import { auth } from "../firebase/firebase";
import * as ROUTES from "./routes";
import { connect } from "react-redux";
import { setNoAuthRedirectFromUrl } from "../redux/actions/uiActions";
import { withRouter } from "react-router-dom";

export class AuthRoute extends Component {
  render() {
    const {
      component: Component,
      authenticated,
      setNoAuthRedirectFromUrl,
      history,
      ...rest
    } = this.props;
    if (!auth.currentUser) {
      setNoAuthRedirectFromUrl(history.location);
    }

    return (
      <Route
        {...rest}
        render={props =>
          auth.currentUser ? (
            <Component {...props} />
          ) : (
            <Redirect to={ROUTES.LOGIN} />
          )
        }
      />
    );
  }
}

const mapStateToProps = state => ({
  authenticated: state.user.authenticated
});

const mapDispatchToProps = {
  setNoAuthRedirectFromUrl
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AuthRoute));
